<template>
  <validation-observer
    v-if="loaded === true"
    ref="validationobserver"
    v-slot="{ handleSubmit }"
  >
    <b-form @submit.prevent="handleSubmit(salvar)">
      <b-row class="w-100">
        <b-col cols="12">
          <b-alert :show="exibirAlertaProgramacaoJaUtilizada" variant="warning">
            Esta programação já foi vinculada ao evento
            <strong>{{ programacaoJaUtilizada?.NmEvento }}</strong>.
          </b-alert>
          <b-alert :show="exibirAlertaTiposDiferentes" variant="warning">
            Os tipos do evento e da programação são diferentes.
          </b-alert>
        </b-col>
      </b-row>
      <h6 v-if="!exibirAlertaProgramacaoJaUtilizada && !exibirAlertaTiposDiferentes" class="mb-3 text-left">
        <b-button class="float-right m-1" size="sm" type="submit">
          <font-awesome-icon icon="save" />
          Salvar
        </b-button>
      </h6>
      <b-row class="w-100">
        <b-col cols="12" sm="6" xl="4">
          <default-form-validation-provider
            label="A programação do evento já foi informada?"
          >
            <b-form-radio-group
              v-model="carregarProgramacoes"
              @change="handleCarregarProgramacoesChange"
              :options="[
                { text: 'Sim', value: 'S' },
                { text: 'Não', value: 'N' },
              ]"
              size="sm"
            >
            </b-form-radio-group>
          </default-form-validation-provider>
        </b-col>
        <b-col v-if="carregarProgramacoes === 'S'" cols="12" sm="6" xl="4">
          <default-form-validation-provider
            label="Programação"
            v-slot="defaultState"
            tag="div"
          >
            <div
              id="programacaoSelectWrapper"
              class="wrapper-multiselect-sagres"
              :class="{
                invalid: programacaoSelecionada.IdProgramacao === null,
                valid: programacaoSelecionada.IdProgramacao !== null,
              }"
            >
              <multiselect
                v-model="programacaoSelecionada"
                close-on-select
                searchable
                :show-labels="false"
                label="NmEvento"
                deselect-label=""
                :allow-empty="true"
                placeholder="Selecione"
                track-by="IdProgramacao"
                :options="listaProgramacoes"
                class="w-100"
                :disabled="!listaProgramacoes"
                :state="defaultState.state"
                @input="programacaoAtualizada"
              >
                <template slot="noOptions">
                  <small><i>Nenhuma programação cadastrada</i></small>
                </template>
                <template slot="noResult">
                  <i>Nenhuma programação encontrada</i>
                </template>
              </multiselect>
            </div>
          </default-form-validation-provider>
        </b-col>
      </b-row>
      <b-row v-if="carregarFormulario" class="w-100">
        <b-col cols="12" sm="6" xl="4">
          <default-form-validation-provider
            label="Título"
            rules="required|max:100"
            v-slot="defState"
          >
            <b-form-input
              v-model="evento.DeTitulo"
              :state="defState.state"
            ></b-form-input>
          </default-form-validation-provider>
        </b-col>
        <b-col cols="12" sm="6" xl="4">
          <default-form-validation-provider
            label="Tipo de Evento"
            v-slot="defaultState"
          >
            <b-form-select
              id="select-tipo"
              v-model="evento.IdTipoEvento"
              :options="listaTipoEvento"
              :state="defaultState.state"
              @change="tipoAtualizado"
            >
            </b-form-select>
          </default-form-validation-provider>
        </b-col>
        <b-col cols="12" sm="6" xl="4">
          <default-form-validation-provider
            label="Valor total dos gastos (R$)"
            v-slot="defState"
          >
            <money
              class="form-control"
              v-model="evento.VlGastoTotal"
              :state="defState.state"
              v-bind="vMoneyOptions"
            ></money>
          </default-form-validation-provider>
        </b-col>
        <b-col cols="12" sm="6" xl="4">
          <default-form-validation-provider
            label="Descrição"
            v-slot="defaultState"
            rules="required|max:500"
          >
            <b-form-textarea
              id="input-descricao"
              :state="defaultState.state"
              v-model="evento.DeDescricao"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </default-form-validation-provider>
        </b-col>
        <b-col cols="12" sm="6" xl="4">
          <default-form-validation-provider
            label="Data de Início"
            v-slot="defaultState"
          >
            <b-form-datepicker
              id="input-data-inicio"
              :state="defaultState.state"
              v-model="evento.DtInicio"
              v-bind="datePickerProps"
            >
            </b-form-datepicker>
          </default-form-validation-provider>
        </b-col>
        <b-col cols="12" sm="6" xl="4">
          <default-form-validation-provider
            label="Data de Término"
            v-slot="defaultState"
          >
            <b-form-datepicker
              id="input-data-termino"
              :state="defaultState.state"
              v-model="evento.DtFim"
              v-bind="datePickerProps"
            >
            </b-form-datepicker>
          </default-form-validation-provider>
        </b-col>
      </b-row>
      <b-card v-if="carregarFormulario" header-tag="header" no-body>
        <template #header>
          <h6 class="mb-0">
            <span class="font-weight-bold">Anexos</span>
          </h6>
        </template>
        <b-card-body>
          <div
            v-for="tipoArquivo in tiposArquivoEvento"
            :key="'arquivoEvento' + tipoArquivo.IdTipoArquivo"
          >
            <b-row class="m-2">
              <b-col cols="6">
                {{
                  tipoArquivo.IdTipoArquivo + " - " + tipoArquivo.DeTipoArquivo
                }}
              </b-col>
              <b-col
                v-if="
                  evento.ArquivoEvento.find(
                    (x) => x.IdTipoArquivo == tipoArquivo.IdTipoArquivo
                  )
                "
                cols="6"
              >
                <div class="d-flex justify-content-center">
                  <btn-download
                    class="mr-2"
                    :fazerDownload="baixarAnexo"
                    :parametros="tipoArquivo.IdTipoArquivo"
                  />
                  <b-link
                    class="text-dark"
                    @click="removerArquivo(tipoArquivo.IdTipoArquivo)"
                  >
                    <font-awesome-icon icon="times" />
                    <div style="font-size: 12px">Remover</div>
                  </b-link>
                </div>
              </b-col>
              <b-col v-else cols="6">
                <validation-provider
                  rules="required"
                  v-slot="validationContext"
                  :name="'arq' + tipoArquivo.IdTipoArquivo"
                >
                  <b-form-file
                    :state="getValidationState(validationContext)"
                    v-model="arquivos[tipoArquivo.IdTipoArquivo]"
                    placeholder="Escolha um arquivo..."
                    drop-placeholder="Solte o arquivo aqui..."
                    class=""
                    browse-text="Escolher"
                    accept=".pdf"
                  ></b-form-file>
                  <b-form-invalid-feedback id="input-arquivo-live-feedback"
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-col>
            </b-row>
          </div>
        </b-card-body>
      </b-card>
    </b-form>
  </validation-observer>
</template>

<script lang="ts">
import { Component, Ref, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { store } from "@/store";
import { UtilsTS } from "@/utilsts";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import {
  DatePickerDefaultProps,
  FormGroupDefaultCols,
} from "@/types/form-default-props";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import eventoService from "@/services/licitacoes/eventosService";
import programacaoService from "@/services/eventos/programacaoService";
import { Evento } from "@/types/eventos/eventos/evento";
import { SelectValue } from "@/types/select-value";
import { TipoArquivoEvento } from "@/types/eventos/eventos/tipo-arquivo-evento";
import { Money } from "v-money";
import Multiselect from "vue-multiselect";
import BtnDownload from "@/components/shared/btn-download.vue";
import { Programacao } from "@/types/eventos/programacao/programacao";

const CompProps = Vue.extend({
  name: "AbaEditarDadosEvento",
  components: {
    DefaultFormValidationProvider,
    ValidationObserver,
    ValidationProvider,
    Money,
    Multiselect,
    BtnDownload,
  },
  props: {
    evt: {
      type: Object,
      required: true,
    },
  },
});

@Component
export default class AbaEditarDadosEvento extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  datePickerProps = DatePickerDefaultProps;
  formGroupCols = FormGroupDefaultCols;
  valorPadraoSelect: SelectValue = {
    value: null,
    text: "SELECIONE UMA OPÇÃO",
    disabled: true,
  };
  listaTipoEvento: SelectValue[] = [this.valorPadraoSelect];
  evento: Evento = new Evento();
  tiposArquivoEvento: TipoArquivoEvento[] = [];
  arquivos: any = [];
  loaded = false;
  carregarProgramacoes: string | null = null;
  programacaoSelecionada: any = { IdProgramacao: null };
  listaProgramacoes: Programacao[] = [];
  programacaoJaUtilizada: {
    ProgramacaoJaUtilizada: boolean;
    IdEvento: number | null;
    NmEvento: string | null;
  } | null = null;

  get carregarFormulario() {
    return (
      !!this.evento.IdEvento ||
      this.carregarProgramacoes === "N" ||
      (this.carregarProgramacoes === "S" &&
        this.programacaoSelecionada.IdProgramacao !== null)
    );
  }

  get exibirAlertaTiposDiferentes() {

    return (
      !store.blockScreen &&
      this.programacaoSelecionada.IdProgramacao !== null &&
      this.programacaoSelecionada.IdTipoEvento !== this.evento.IdTipoEvento
    );
  }

  get exibirAlertaProgramacaoJaUtilizada() {
    return (
      !store.blockScreen &&
      this.programacaoSelecionada.IdProgramacao !== null &&
      this.programacaoJaUtilizada !== null &&
      this.programacaoJaUtilizada.ProgramacaoJaUtilizada &&
      this.programacaoJaUtilizada.IdEvento !== this.evento.IdEvento
    );
  }

  async handleCarregarProgramacoesChange() {
    if (this.carregarProgramacoes === "N") {
      if (!this.evento.IdEvento) {
        this.evento.DeTitulo = "";
        this.evento.IdTipoEvento = null;
        this.evento.DtInicio = null;
        this.evento.DtFim = null;
      }
      this.evento.IdProgramacao = null;
      this.programacaoSelecionada = { IdProgramacao: null };
    } else {
      const programacoesResponse =
        await programacaoService.listarProgramacoes();
      this.listaProgramacoes = [
        { IdProgramacao: null, NmEvento: "SELECIONE" },
        ...programacoesResponse,
      ];
    }
  }

  async salvar(): Promise<void> {
    store.blockScreen = true;
    try {
      const isValid = await this.validationobserver.validate();
      if (!isValid) {
        console.error(this.validationobserver);
      } else {
        //salvar a programacao
        const retorno = this.evento.IdEvento
          ? await eventoService.editarEvento(this.evento, this.arquivos)
          : await eventoService.adicionarEvento(this.evento, this.arquivos);
        this.$emit("atualizarEvento", retorno);
        this.$toast.success(`Os dados do evento foram salvos!`);
        this.evento = Object.assign(new Evento(), retorno);
        this.evento.tratarDadosDaAPI();
        this.$router.push("/modulo-eventos/eventos");
      }
    } catch (e: any) {
      this.tratarError(e, true);
    } finally {
      store.blockScreen = false;
    }
  }

  async montarCombos(): Promise<void> {
    const response = await eventoService.listarTiposEvento();
    this.listaTipoEvento.push(
      ...response.data.map((t) => {
        return { value: t.IdTipoEvento, text: t.DeTipoEvento };
      })
    );
  }

  async mounted() {
    try {
      store.blockScreen = true;
      this.arquivos = [null, null, null, null, null, null, null, null, null];

      if (this.evt.IdEvento > 0) {
        this.evento = this.evt;
        this.evento.tratarDadosDaAPI();
        if (this.evento.IdProgramacao !== null) {
          this.carregarProgramacoes = "S";
          await this.handleCarregarProgramacoesChange();
          this.programacaoSelecionada = this.listaProgramacoes.find(
            (x) => x.IdProgramacao === this.evento.IdProgramacao
          );
        }
      }
      await this.montarCombos();
      const responseTiposArquivoEvento =
        await eventoService.listarTiposArquivoEvento();
      this.tiposArquivoEvento = responseTiposArquivoEvento.data;
      this.loaded = true;
    } catch (e: any) {
      console.error("Problema ao montar o componente AbaEditarDadosEvento", e);
    } finally {
      store.blockScreen = false;
    }
  }

  getValidationState({ dirty, validated, valid = null }): any {
    return dirty || validated ? valid : null;
  }

  existeArquivo(tipoArquivo: number) {
    const arquivo = this.evento.ArquivoEvento.find(
      (x) => x.IdTipoArquivo == tipoArquivo
    );
    return arquivo ? true : false;
  }

  async removerArquivo(tipoArquivo: number) {
    const indexArq = this.evento.ArquivoEvento.findIndex(
      (x) => x.IdTipoArquivo == tipoArquivo
    );
    if (indexArq >= 0) this.evento.ArquivoEvento.splice(indexArq, 1);
    const tiposArquivoTemp = this.tiposArquivoEvento;
    this.tiposArquivoEvento = [];
    this.tiposArquivoEvento = tiposArquivoTemp;
  }

  async baixarAnexo(tipoArquivo: number) {
    const arquivo = this.evento.ArquivoEvento.find(
      (x) => x.IdTipoArquivo == tipoArquivo
    );
    const response = await eventoService.baixarAnexo(arquivo?.IdArquivo);
    this.download(arquivo?.DeNomeArquivo, response.data);
  }

  async programacaoAtualizada() {
    try {
      store.blockScreen = true;

      this.evento.IdProgramacao = this.programacaoSelecionada?.IdProgramacao;
      this.programacaoJaUtilizada = await programacaoService.checarProgramacao(
        this.programacaoSelecionada.IdProgramacao
      );

      if (!this.evento.IdEvento) {
        this.evento.DeTitulo = this.programacaoSelecionada.NmEvento;
        this.evento.IdTipoEvento = this.programacaoSelecionada.IdTipoEvento;
        this.evento.DtInicio =
          new Date(this.programacaoSelecionada.AtracaoArtistica[0].DtInicio) ||
          null;
        this.evento.DtFim =
          new Date(
            this.programacaoSelecionada.AtracaoArtistica[
              this.programacaoSelecionada.AtracaoArtistica.length - 1
            ].DtInicio
          ) || null;
      }
    } finally {
      store.blockScreen = false;
    }
  }

  async tipoAtualizado() {
    try {
      store.blockScreen = true;
    } finally {
      store.blockScreen = false;
    }
  }
}
</script>

<style></style>